import styled from 'styled-components';

export const NavWrapper = styled.div<{ $navOpen?: boolean }>`
  position: fixed;
  bottom: 0;
  /* Dynamic rail z-index, gated on expand ($navOpen):
       - COLLAPSED -> layer2 (300): below the StormUI FocusOverlay (layer3/500) and the
         Sheet/Modal (layer4/700), so any focus surface covers the idle icon rail.
       - EXPANDED  -> layer3 + 1 (501): above the FocusOverlay so the expanded rail stays
         visible/usable during a focus task, still below the Sheet/Modal (700) so a
         full-screen Sheet covers it (you can't hover-expand under a Sheet anyway).
     The sidenav's OWN popovers still escape ABOVE every focus surface by portalling into
     SidenavPopoverPortal (escalated ~10000 via useEscalatedPortalZIndex), independent of
     this value. Chrome-level FOCUS / FOCUS_NO_HEADER layouts don't render Nav
     (shouldRenderMenu). layer3's token is a string, so coerce to Number before +1 (a
     string concat would yield "5001", above the 700 Sheet). */
  z-index: ${({ theme, $navOpen }) =>
    $navOpen
      ? Number(theme.elevation.zIndex.layer3) + 1
      : theme.elevation.zIndex.layer2};
`;

/**
 * Host that sidenav popovers portal into (future feature-highlight popovers, etc.).
 * `position: relative` is load-bearing: it lets the z-index that `Nav` assigns at
 * runtime via `useEscalatedPortalZIndex` (nearest-ancestor + inline-portal increment)
 * form a stacking context. It sits OUTSIDE `NavWrapper` (which has `overflow: hidden`)
 * so a popover can escape the rail, and the runtime escalation lets an explicitly-opened
 * sidenav popover paint above a StormUI `FocusOverlay` even though the rail itself stays
 * below it. No sidenav popover exists today; this is future-proofing.
 */
export const SidenavPopoverPortal = styled.div`
  position: relative;
`;
